var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"article-quote"},[_c('span',{staticClass:"article-quote__icon"}),_vm._v(" "),_c('blockquote',{staticClass:"article-quote__wrap",domProps:{"innerHTML":_vm._s(_vm.body)}})])}
var staticRenderFns = []

export { render, staticRenderFns }